var isArray = Array.isArray;
var isArray_1 = isArray;
export { isArray_1 as i };